// The Symbol used for text rules types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
const hasSymbol = typeof Symbol === 'function'

export const WORD = hasSymbol ? Symbol('word') : 0xff00
export const WHITE_SPACE = hasSymbol ? Symbol('white space') : 0xff02
export const NEW_LINE = hasSymbol ? Symbol('new line') : 0xff03

const breakingSpaces = [
  '', // first string to apply join correctly
  '0009', // character tabulation
  '0020', // space
  '2000', // en quad
  '2001', // em quad
  '2002', // en space
  '2003', // em space
  '2004', // three-per-em space
  '2005', // four-per-em space
  '2006', // six-per-em space
  '2008', // punctuation space
  '2009', // thin space
  '200A', // hair space
  '205F', // medium mathematical space
  '3000', // ideographic space
].join('\\u')

export const RTL_PATTERN = /[\u0591-\u07FF\uFB1D-\uFDFF\uFE70-\uFEFC]+/
export const WHITE_SPACE_PATTERN = new RegExp(`[${breakingSpaces}]+`)
export const NEW_LINE_PATTERN = /[\n\r\u2028\u2029]/
